<template>
    <div>
        <Hero bg="/static/img/open_application/open_app_backgr_pic.jpg" title="Open<br />Application"
              :theme="'primary'">
            <p class="paragraph">Sometimes we don't yet know that we need you, so we need you to tell us! After all, we
                always have a place for exceptional people. </p>
            <p class="paragraph">So, if you want to work at Bohemia but can't find the right job opening, you're always
                welcome to send us an open application. Tell us who you are and what you'd like to do, and perhaps
                there's an opportunity for you, now or in the future.</p>

            <div class="button-wrapper">
                <BasicButton class="content__link" type="black" v-scroll-to="{ element: '#form', duration: 1000 }">Send
                    Open Application
                </BasicButton>
            </div>
        </Hero>
        <div class="header--section container compact-padding">
            <h1 class="heading--xl text-uppercase header--section__heading">Talent always<br/> welcome</h1>
            <p class="paragraph">So, if you want to work at our company but can't find the right job opening, you're
                always welcome to send an open application.
                Let us know a little bit about who you are and what you'd like to do, and we can discuss any potential
                opportunities
            </p>
        </div>
        <ApplicationForm :is-open-application="true" id="form">
            <template slot="heading">
                <h2 class="heading--sm text-capitalize main-heading text-center">Unsolicited Job Application</h2>
                <p class="paragraph text-center">Make sure to include a cover letter and a CV.
                    We receive lots of applications, and a well-written intro really takes your application to the next
                    level. </p>
                <div class="divider"></div>
                <hr/>
            </template>
        </ApplicationForm>
        <ScrollTopButton/>
    </div>
</template>

<script>
  import Hero from "../components/common/HerroConstructor";
  import BasicButton from "../components/BasicButton";
  import UnsolicitedForm from "../components/applicationPageComponents/UnsolicitedForm";
  import ApplicationForm from "../components/applicationPageComponents/ApplicationForm";

  export default {
    name: "open-application",
    components: {
      UnsolicitedForm,
      Hero,
      BasicButton,
      ApplicationForm,

    },
    metaInfo() {
      return {
        title: "Open job application",
        htmlAttrs: {
          lang: "en",
          metaInfo: {
            meta: [
              { charset: "utf-8" },
              { name: "og:title", content: "Open application" },
              { name: "description", content: "Bohemia Interactive open application page" },
              { name: "og:image", content: "Bohemia Interactive position page" },
              { name: "og:type", content: "Open application page" }

            ]
          }

        }

      };
    }
  };
</script>

<style scoped lang="scss" type="text/scss">
    @import "../assets/scss/globals";

    #form {
        padding-bottom: 40px;
    }

    .header--section {
        padding: 5em;
        @media (max-width: $compact) {
            padding: 3em;
        }
    }

    .header--section__heading {
        margin-top: 62px;
        margin-bottom: 62px;
        @media (max-width: $compact) {
            margin-top: 10px;
            margin-bottom: 20px;
        }
    }

    .main-heading {
        text-transform: uppercase;
        font-size: 36px;
        font-weight: 800;
        letter-spacing: 0.72px;
        font-family: Montserrat, sans-serif;
        margin-top: 60px;
        margin-bottom: 40px;
    }

    .paragraph {
        font-family: "Inter UI", sans-serif;
        font-size: 16px;
        letter-spacing: 0.02px;
        line-height: 28px;
        font-weight: 400;
    }

    .sub-header {
        font-size: 35px;
        font-family: "Montserrat", sans-serif;
        margin-bottom: 45px;
        margin-top: 75px;
        font-weight: 300;
        letter-spacing: 0.19px;
        word-wrap: break-word;

        @media (max-width: $tablet) {
            font-size: 22px;
        }
    }

    .text {
        margin-top: 45px;
        word-wrap: break-word;
    }

    .button-wrapper {
        @media (max-width: $compact) {
            display: flex;
            justify-content: center;
            align-self: center;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/OpenApplication.vue